import {WebFormModel} from "capitalist-shared/src/core/model";
import axios from "axios";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";

export class LegalVerificationApplicationModel extends WebFormModel {

  loadStatus = new RemoteRequestState();
  submitStatus = new RemoteRequestState();

  values = {
    activity: '',
    firstName: '',
    lastName: '',
    middleName: '',
    birthDay: '',
    name: '',
    number: '',
    address: '',
    bankName: '',
    bankAccount: '',
    bankSwift: '',
    bankNationalCode: '',
    bankAddress: '',
    bankCountry: '',
    country: ''
  }

  options = {
    country: null
  }

  get countryOptions() {
    return this.options.country ?? [];
  }

  submit() {
    this.submitStatus.loadStart();
    return axios.post('/webapi/profile/update', {
      call: 'applylegal'
    }).then(result => {

      this.submitStatus.loadEnd();
      return result.data.model;
    }).catch(err => {
      this.checkAxiosError(err);
      this.submitStatus.loadError();
      throw err;
    });
  }

  loadModel() {
    this.loadStatus.loadStart();
    return axios.post('/webapi/profile/update', {
      call: 'legalmodel'
    }).then(result => {
      this._setData(result.data.model);
      this.loadStatus.loadEnd();
      return result.data.model;
    }).catch(err => {
      this.loadStatus.loadError();
      throw err;
    });
  }
}


export class DataSaver {

  keyName: string = 'update-form';
  version: number = 1;

  constructor(keyName: string = 'form') {
    this.keyName = keyName;
  }

  save(data: any) {
    try {
      localStorage.setItem(this.keyName, JSON.stringify({version: this.version, data: data}));
    } catch (e) {
      // if (e == QUOTA_EXCEEDED_ERR) {
      //
      // }
      return false;
    }
    return true;
  }

  getData(): any {
    try {
      const result: any = JSON.parse(localStorage.getItem(this.keyName));
      if (!!result
        && (typeof result === 'object')
        && ('version' in result)
        && (result.version == this.version)
        && ('data' in result))
        return result.data;
    } catch (e) {
    }
    return null;
  }

  hasData(): boolean {
    return !!this.getData();
  }

  clear() {
    localStorage.removeItem(this.keyName);
  }
}
